import React from "react";

import Error from './ErrorBlock'
import BlockBodyCopy from "./blocks/BlockBody";
import {Container, Row} from 'react-bootstrap'

const registeredBlocks = {
  ContentfulModuleBodyCopy: BlockBodyCopy
};

const Flexible = ({blocks, slug}) =>
  // Dynamic ACF Flexible Content Blocks handling
  blocks ? (
    <Container fluid className="flexible-content">
      {/* Render any found Flexible content blocks */
      blocks && blocks.length
        ? blocks.map((block, i) => {
            /* Get block slug from ACF id */
            //console.log(block)
            const {__typename} = block ? block : {__typename: null}

            let JSX = Error;
            /* Check current page slug for registered block */
           JSX = registeredBlocks[__typename]
            return JSX ? (
              <Row key={__typename + i}>
                <JSX block={block} slug={slug}/>
              </Row>
            ) : null;
          })
        : null}
    </Container>
  ) : null;

export default Flexible;
